import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import bellImg from './bell.png';

const styles = () =>
  createStyles({
    container: {
      borderTop: '1px solid #c9cacc',
      marginLeft: -8,
      padding: '24px 12px 16px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 12,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 4,
      width: '100%',
    },
    icon: {
      width: 72,
      height: 72,
    },
    title: {
      fontFamily: 'GolosTextWebMedium, Roboto',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      color: '#171717',
      opacity: 0.9,
      textAlign: 'center',
      margin: 0,
    },
    subtitle: {
      fontFamily: 'GolosTextWebRegular, Roboto',
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '16px',
      color: '#737373',
      opacity: 0.9,
      textAlign: 'center',
      margin: 0,
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: 36,
      padding: '8px 16px',
      border: 'none',
      borderRadius: 8,
      backgroundColor: '#171717',
      fontFamily: 'GolosTextWebMedium, Roboto',
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
      color: '#fafafa',
      cursor: 'pointer',
      textDecoration: 'none',
      transition: 'opacity 0.2s',
      '&:hover': {
        opacity: 0.85,
      },
    },
  });

interface IProps extends WithStyles<typeof styles> {
  href?: string;
}

const NewVersionBanner: React.FC<IProps> = ({ classes, href = 'https://lk.guestme.ru/' }) => (
  <div className={classes.container}>
    <div className={classes.content}>
      <img className={classes.icon} src={bellImg} alt="" />
      <p className={classes.title}>Появилась новая версия!</p>
      <p className={classes.subtitle}>Быстрее и удобнее. Переключитесь, чтобы проверить.</p>
    </div>
    <a className={classes.button} href={href}>
      Переключиться
    </a>
  </div>
);

export default withStyles(styles)(NewVersionBanner);
